const GoogleWebDevIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="93.676"
      height="16.999"
      viewBox="0 0 93.676 16.999"
    >
      <g id="lockup" transform="translate(-0.607 -0.785)">
        <path
          id="Caminho_11562"
          data-name="Caminho 11562"
          d="M20.089,17.3H13.354a.455.455,0,0,0-.3.076l-5.07,4.011a.142.142,0,0,0,0,.227c0,.076.076.076.151.076H20.165a2.2,2.2,0,1,0-.076-4.389"
          transform="translate(-1.78 -4.018)"
          fill="#8a8a8a"
          fillRule="evenodd"
        />
        <g
          id="Grupo_11141"
          data-name="Grupo 11141"
          transform="translate(0.607 0.785)"
        >
          <path
            id="Caminho_11563"
            data-name="Caminho 11563"
            d="M12.175,8.34a2.518,2.518,0,0,0-.832-1.589L3.549.546a2.184,2.184,0,0,0-3.1.378,2.184,2.184,0,0,0,.378,3.1L6.5,8.567.824,13.108a2.184,2.184,0,0,0-.378,3.1,2.184,2.184,0,0,0,3.1.378l7.794-6.356a2.262,2.262,0,0,0,.832-1.74V8.34"
            transform="translate(0.032 -0.068)"
            fill="#8a8a8a"
            fillRule="evenodd"
          />
        </g>
        <path
          id="Caminho_11564"
          data-name="Caminho 11564"
          d="M25.589,19.494A2.194,2.194,0,1,1,23.394,17.3a2.2,2.2,0,0,1,2.194,2.194"
          transform="translate(-5.01 -4.018)"
          fill="#8a8a8a"
          fillRule="evenodd"
        />
        <path
          id="Caminho_11565"
          data-name="Caminho 11565"
          d="M99.626,15.891H97.961l-3.632-9h1.816l2.648,6.962,2.648-6.962h1.816l-3.632,9ZM86.913,10.367h5.146a2.4,2.4,0,0,0-2.573-2.194A2.588,2.588,0,0,0,86.913,10.367Zm2.724,5.827a4.516,4.516,0,0,1-4.54-4.767,4.5,4.5,0,0,1,4.465-4.767c2.648,0,4.389,1.816,4.389,4.919v.151H86.913a2.939,2.939,0,0,0,2.876,2.951,2.7,2.7,0,0,0,2.5-1.589l1.513.757a4.707,4.707,0,0,1-4.162,2.346Zm-10.594,0a4.571,4.571,0,0,1-4.313-4.767,4.571,4.571,0,0,1,4.313-4.767,3.765,3.765,0,0,1,3.1,1.513h.076l-.076-1.211V2.8h1.665V15.891H82.222V14.68h-.076a3.872,3.872,0,0,1-3.1,1.513Zm.227-1.513c1.665,0,2.876-1.286,2.876-3.254a2.978,2.978,0,0,0-2.876-3.254A3.023,3.023,0,0,0,76.4,11.427,3.023,3.023,0,0,0,79.271,14.68Zm-5.146.076a1.215,1.215,0,0,1-1.286,1.211,1.315,1.315,0,0,1-1.286-1.211,1.261,1.261,0,0,1,1.286-1.211A1.215,1.215,0,0,1,74.125,14.756Zm-7.945-.076a3.023,3.023,0,0,0,2.876-3.254,3.023,3.023,0,0,0-2.876-3.254A2.978,2.978,0,0,0,63.3,11.427,2.978,2.978,0,0,0,66.179,14.68Zm.3,1.513a3.765,3.765,0,0,1-3.1-1.513H63.3v1.211H61.715V2.8H63.38V6.962L63.3,8.173h.076a3.664,3.664,0,0,1,3.1-1.513A4.571,4.571,0,0,1,70.8,11.427,4.623,4.623,0,0,1,66.482,16.194ZM53.315,10.367h5.146a2.4,2.4,0,0,0-2.573-2.194A2.588,2.588,0,0,0,53.315,10.367Zm2.724,5.827a4.516,4.516,0,0,1-4.54-4.767,4.5,4.5,0,0,1,4.465-4.767c2.648,0,4.389,1.816,4.389,4.919v.151H53.315a2.939,2.939,0,0,0,2.876,2.951,2.776,2.776,0,0,0,2.5-1.589l1.513.757a4.707,4.707,0,0,1-4.162,2.346ZM51.272,6.962l-2.876,9h-1.74l-2.27-6.886-2.194,6.886h-1.74l-2.951-9h1.74l1.967,6.81L43.4,6.962h1.74l2.194,6.81L49.3,6.962h1.967Z"
          transform="translate(-8.976 -0.49)"
          fill="#8a8a8a"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default GoogleWebDevIcon;
